import React from 'react'
import classNames from 'classnames'

import './style.scss'

class Image extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      imageIsLoaded: false
    }
  }

  handleImageLoaded() {
    this.setState({
      imageIsLoaded: true
    })
  }

  render() {
    return (
      <div className={this.state.imageIsLoaded ? 'image-loading' : 'image-loaded'}>
        <span className={classNames({'with-gradient' : this.props.withGradient})}>
          <img alt={this.props.alt}
               onLoad={this.handleImageLoaded.bind(this)}
               src={this.props.src}
               srcSet={this.props.srcSet ? this.props.srcSet : null}
          />
        </span>
        <img alt="" src={require('../../assets/images/dummy.png')}/>
      </div>
    )
  }
}

export default Image
